import React, { useRef } from "react";
import "./SpotlightCard.css";

const SpotlightCard = ({ children, className = "" }) => {
  const cardRef = useRef(null);

  const handlePointerMove = (e) => {
    if (!cardRef.current) return;

    const rect = cardRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    // Spotlight tracking
    cardRef.current.style.setProperty("--x", x.toFixed(2));
    cardRef.current.style.setProperty("--y", y.toFixed(2));

    // 3D tilt: calculate offset from center (-1 to +1)
    const cx = rect.width / 2;
    const cy = rect.height / 2;
    const dx = (x - cx) / cx; // -1 = left edge, +1 = right edge
    const dy = (y - cy) / cy; // -1 = top edge, +1 = bottom edge

    const maxTilt = 12; // degrees
    const rotateY = (dx * maxTilt).toFixed(2);
    const rotateX = (-dy * maxTilt).toFixed(2);

    cardRef.current.style.transform = `perspective(800px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale3d(1.03, 1.03, 1.03)`;
  };

  const handlePointerLeave = () => {
    if (!cardRef.current) return;

    // Reset spotlight
    cardRef.current.style.setProperty("--x", "-1000");
    cardRef.current.style.setProperty("--y", "-1000");

    // Reset tilt smoothly (CSS transition handles the animation back)
    cardRef.current.style.transform = "perspective(800px) rotateX(0deg) rotateY(0deg) scale3d(1, 1, 1)";
  };

  return (
    <div
      ref={cardRef}
      className={`spotlight-card ${className}`}
      onPointerMove={handlePointerMove}
      onPointerLeave={handlePointerLeave}
      data-glow
    >
      <div data-glow></div>
      <div className="spotlight-card-content">{children}</div>
    </div>
  );
};

export { SpotlightCard };

